import {
  clickEventType,
} from './helpers';

$(document).ready(() => {
  $(document).on(clickEventType, '.full-row-link', (event) => {
    window.location.href = $(event.currentTarget).data('link');
  });
});
